import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57b1562e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-logo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "description" }

import { computed } from 'vue';
  import { IImage } from '@/types/image';
  import Logo from '../images/logo.png';

  export interface IProps {
    title?: string;
    description?: string;
    image?: string;
    showBgOverlay?: boolean;
    logos?: IImage[];
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    description: null,
    image: null,
    showBgOverlay: { type: Boolean, default: true },
    logos: null
  },
  setup(__props: any) {

const props = __props as { title?: string, description?: string, image?: string, showBgOverlay: boolean, logos?: IImage[] }

  

  const logos = computed(() => {
    return props.logos?.length ? props.logos.map(item => item.url) : [Logo];
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "banner",
    style: _normalizeStyle({ backgroundImage: `url('${__props.image}')` })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["mask", { 'overlay': __props.showBgOverlay }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logos), (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            src: item,
            class: "logo",
            alt: "Logo"
          }, null, 8, _hoisted_2))
        }), 128))
      ]),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1)
    ], 2)
  ], 4))
}
}

})